// Centralized configuration for API endpoints or constants
const config = {
    apiBaseUrl: null, // No localhost fallback - must be determined dynamically
    loginUrl: "null",
    apiHost: null, // No localhost fallback - must be determined dynamically

  };
  
  export default config;